/**
 * Created by chengy on 2019/6/27.
 */
export const baseApiMap = {
  //警种
  pcc:'/base/v1/pcc',
  //根据pid查询字典
  pidDict:'/base/hubeigat/dict/',
  //字典
  dict:'/base/v1/dict/',
  //区域
  region:'/base/v1/region/',
  //违法行为
  violationBehavior:'/base/v1/violationkey/',

  //创建验证码
  create:'/base/captcha/v1',
  //验证码验证
  captcha:'/base/captcha/v1/verify',

  captchaV2:'/base/captcha/get',
  captchaCheck:'/base/captcha/check',

  //帮助中心-主菜单
  helpMenu:'/base/helpcenter/v1/helpMenu',
  //帮助中心-子菜单
  helpTitle:'/base/helpcenter/v1/helpTitle/',
  //帮助中心-事项汇总
  matterCollects:'/base/helpcenter/v1/getMatterCollects',
  //帮助中心-事项列表
  matterStaisitics:'/base/helpcenter/v1/getMatterStaisitics',

  //选择公安机关
  resSub:'/base/dept/v1/res-sub',
  // 获取部门列表（所有可用）
  allDeptList: '/base/hubeigat/dept/res-sub',
  //获取部门信息
  resDept:'/base/dept/v1/res-dept/',
  //获取带分页的组织机构数据
  deptPage:'/base/dept/v1/page',
  //根据警种和区域获取部门信息
  deptList:'/base/dept/v1/list',
  //获取举报类型
  clueType:'/base/v1/dict/dict_crtype',
  // 获取投诉发生时间
  clueTime: '/base/v1/dict/halfyears',
  //注册地区
  registeredaArea: '/base/v1/region',

}
